import { render, staticRenderFns } from "./TermRules.vue?vue&type=template&id=055108b0&scoped=true"
import script from "./TermRules.vue?vue&type=script&lang=js"
export * from "./TermRules.vue?vue&type=script&lang=js"
import style0 from "./TermRules.vue?vue&type=style&index=0&id=055108b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055108b0",
  null
  
)

export default component.exports